import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { SettledLoansDetails } from '../../model/rbi-compliance/loan-settlement-negotiation.model';

@Injectable({
  providedIn: 'root'
})
export class LoanSettlementNegotiationService {

  constructor(private readonly http: HttpClient) { }

  async getLoanSettlementNegotiationByLenderId(lenderId: string): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-settlement-negotiation/lender/${lenderId}`;
    return await this.http.get(url).toPromise();
  }

  async updateLoanSettlementNegotiation(id: string, settledLoansDetails: SettledLoansDetails): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-settlement-negotiation/lender/${id}`;
    return await this.http.put(url, { settledLoansDetails }).toPromise();
  }
}
